import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import {
  Translations,
  convertStringToArray,
  convertStringToArrayForRadio
} from '../../../../utils';
// restClient
import { eapiClient, aemHostClient } from '../../../../restClient';
// children
import Radiobutton from '../../../common/Radio/radioButton';
import SimpleDropdown from "../../../common/SimpleDropdown/index";
//style
import './styles.css';

class IndiaDeclarationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countryFormData: {
        countryIndiaDecForm: {
          bankDetails: [],
        },
        id: '',
        lid: '',
      },
      noOfBankName: 1,
      methodFlag: false,
      dataReady: false
    };

  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  translateWordForRadio = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    return convertedArray;
  }

  componentWillMount() {
    let apiURL = "/aemData/formData/json_india-declaration-letter-form";
    if (this.props.mode === "edit") {
      apiURL = apiURL.replace("json_add-", "json_edit-");
    }
    aemHostClient(apiURL)
      .then(({ data }) => {
        this.setState({ formJson: data });
      });

    var { caseId, productId } = this.props.match.params;
    eapiClient("/countryForms/case/" + caseId + "/product/" + productId)
      .then(({ data }) => {
        this.setState({ entityName: data.responseData.entityName })
        if (data.responseData.countryIndiaDecForm !== undefined) {
          this.setState({
            countryFormData: data.responseData,
            dataReady: true
          });
          this.setState({ methodFlag: true })
          const _banksD = data.responseData.countryIndiaDecForm.bankDetails;
          if (_banksD && _banksD.length > 0 && this.state.noOfBankName !== _banksD.length) {
            this.setState({ noOfBankName: _banksD.length });
          }
        } else {

          this.setState({
            countryFormData: {
              ...this.state.countryFormData, id: data.responseData.id
            }
          });
          this.setState({ countryFormData: { ...this.state.countryFormData, lid: data.responseData.lid } });
          this.setState({ dataReady: true })
        }
      });
  }


  getFormData = (formData) => {
    this.setState({ formData });
  }

  onFormSubmit = (event, apiURL) => {

  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  saveForm = () => {
    var countryIndiaDecForm = {};
    var payLoad = {};
    var { caseId, productId } = this.props.match.params;
    countryIndiaDecForm.bankDetails = this.state.countryFormData.countryIndiaDecForm.bankDetails;
    countryIndiaDecForm.creditFacilityDescription = this.state.countryFormData.countryIndiaDecForm.creditFacilityDescription;
    countryIndiaDecForm.acceptForeignContribution = this.state.countryFormData.countryIndiaDecForm.acceptForeignContribution;
    countryIndiaDecForm.registeredOutsideIndia = this.state.countryFormData.countryIndiaDecForm.registeredOutsideIndia;
    countryIndiaDecForm.liaisonOffice = this.state.countryFormData.countryIndiaDecForm.liaisonOffice;
    countryIndiaDecForm.noOfSign = parseInt(this.state.countryFormData.countryIndiaDecForm.noOfSign);
    payLoad.countryIndiaDecForm = countryIndiaDecForm;
    payLoad.caseId = caseId;
    payLoad.productId = productId;
    payLoad.id = this.state.countryFormData.id;
    payLoad.lid = this.state.countryFormData.lid
    payLoad.countryFormName = "India declaration letter";
    let apiURL;

    apiURL = "/countryForms/case/" + caseId + "/product/" + productId;
    eapiClient(apiURL, {
      method: 'PUT',
      data: JSON.stringify(payLoad)

    })
      .then(({ data }) => {
      });
    this.props.history.goBack();
  }

  onBankDetailsDeletion = (index) => {
    let _bankDetails = [...this.state.countryFormData.countryIndiaDecForm.bankDetails];
    _bankDetails.splice(index, 1);
    this.setState(prevState => {
      return {
        noOfBankName: prevState.noOfBankName - 1,
        countryFormData: { countryIndiaDecForm: { ...prevState.countryFormData.countryIndiaDecForm, bankDetails: _bankDetails } }
      }
    });
  }


  onBankAddition = () => {
    this.setState(prevState => {
      return { noOfBankName: prevState.noOfBankName + 1 }
    });
    document.getElementsByClassName("bank-name-wrapper")[this.state.noOfBankName - 1].childNodes[0].childNodes[1].focus()
  }
  setCreditFacilities = (value, name) => {
    this.setState({ countryFormData: { countryIndiaDecForm: { ...this.state.countryFormData.countryIndiaDecForm, creditFacilityDescription: value } } });
  }

  setAcceptingForeign = (value, name) => {
    this.setState({ countryFormData: { countryIndiaDecForm: { ...this.state.countryFormData.countryIndiaDecForm, acceptForeignContribution: value } } });
  }

  setRegisteredOutside = (value, name) => {
    this.setState({ countryFormData: { countryIndiaDecForm: { ...this.state.countryFormData.countryIndiaDecForm, registeredOutsideIndia: value } } });
  }

  setHaveBranch = (value, name) => {
    this.setState({ countryFormData: { countryIndiaDecForm: { ...this.state.countryFormData.countryIndiaDecForm, liaisonOffice: value } } });
  }
  setBankname = (index, event) => {

    const bankName = event.target.value;
    let _bankDetails = [...this.state.countryFormData.countryIndiaDecForm.bankDetails];

    if (!_bankDetails[index - 1]) {
      _bankDetails[index - 1] = { bankName };
    } else {
      _bankDetails[index - 1].bankName = bankName;
    }

    this.setState({ countryFormData: { countryIndiaDecForm: { ...this.state.countryFormData.countryIndiaDecForm, bankDetails: _bankDetails } } });

  }

  setAccountNumber = (index, event) => {
    const accountNumber = event.target.value;
    let _bankDetails = [...this.state.countryFormData.countryIndiaDecForm.bankDetails];
    if (!_bankDetails[index - 1]) {
      _bankDetails[index - 1] = { accountNumber };
    } else {
      _bankDetails[index - 1].accountNumber = accountNumber;
    }
    this.setState({ countryFormData: { countryIndiaDecForm: { ...this.state.countryFormData.countryIndiaDecForm, bankDetails: _bankDetails } } });
    //  this.setState({bankDetails:_bankDetails});
  }

  setSignatoriesRequired = (event) => {
    this.setState({ countryFormData: { countryIndiaDecForm: { ...this.state.countryFormData.countryIndiaDecForm, noOfSign: event.target.value } } })
  }

  render() {
    let addBankJsx = "";
    //if(this.props.currentProductAccount.data.eChannelReporting && this.props.currentProductAccount.data.eChannelReporting.length >= 0){
    let buttonJsx = (<h3>Loading.....</h3>);
    if (this.state.formJson !== undefined) {
      buttonJsx = (<div>
        <button onClick={this.saveForm} aria-label={this.state.formJson.guideContainer.rootPanel.items.guidebutton_saveAndReturn.text} className="gdocs-btn-submit"> {this.translations(this.state.formJson.guideContainer.rootPanel.items.guidebutton_saveAndReturn.text)}</button>
      </div>);
      addBankJsx = (
        <button className="gdocs-btn-default marg-bottom" onClick={this.onBankAddition}><i className="icon icon-add"></i> {`${this.translations(this.state.formJson.guideContainer.rootPanel.items['slotcontrol_slot1'].addText)} ${this.state.noOfBankName + 1}`}</button>
      );
    }
    //}
    let indiaDeclarationFormJsx = [];
    for (var i = 1; i <= this.state.noOfBankName; i++) {
      if (this.state.countryFormData !== undefined && this.state.formJson !== undefined) {

        indiaDeclarationFormJsx.push(<div className="bank-name-wrapper"><div className="credit-facilities-wrapper">
          <label for={'bankName' + [i]} className="credit-facilities-position">{`${this.translations(this.state.formJson.guideContainer.rootPanel.items['guidetextbox_IND2-i'].title)} ${i} ${this.translations(this.state.formJson.guideContainer.rootPanel.items['guidetextbox_IND2-i'].text)}`}</label>
          <div className="credit-facilities-position">
            {(i > 1) ? <button className="delete-btn" onClick={this.onBankDetailsDeletion.bind(this, i - 1)}><i className="icon icon-bin"></i></button> : ''}
            <div>
              <input type="text" autoFocus id={'bankName' + [i]} value={this.state.countryFormData.countryIndiaDecForm.bankDetails[i - 1] !== undefined ?
                this.state.countryFormData.countryIndiaDecForm.bankDetails[i - 1].bankName : ''}
                className="inputxt" name="bankName" onChange={this.setBankname.bind(this, i)} />
            </div>
          </div>
        </div>
          <div className="credit-facilities-wrapper">
            <label for="accountNumber" className="credit-facilities-position">{this.translations(this.state.formJson.guideContainer.rootPanel.items['guidetextbox_IND3-i'].title)}</label>
            <input type="text" id="accountNumber" value={this.state.countryFormData.countryIndiaDecForm.bankDetails[i - 1] !== undefined ?
              this.state.countryFormData.countryIndiaDecForm.bankDetails[i - 1].accountNumber : ''}
              className="inputxt" name="accountNumber" onChange={this.setAccountNumber.bind(this, i)} />

          </div>
        </div>
        );
      }
    }

    const pageTitle = this.state.formJson ? this.state.formJson.guideContainer.rootPanel.items.static_text_mainTitle : {};
    return ((this.state.dataReady && this.state.formJson !== undefined) ? (<div className="form-container">
      <div className="gdocs-clear-float"></div>
      <div className="form-title">
        <h2 className="form-heading">{this.translations(pageTitle.name)}</h2>
        <div className="gdocs-clear-float"></div>
        <p className="pannel-sub-heading">{this.state.entityName}</p>
        <p className="form-required-desc optional-text">{this.translations(pageTitle.text)}</p>
      </div>
      <div className="india-declaration-form">
        <fieldset className="credit-facilities-wrapper">
          <legend className="credit-facilities-position">{this.translations(this.state.formJson.guideContainer.rootPanel.items['guideradiobutton_IND1-i'].title)}</legend>
          <div className="credit-facilities-position">
            <label>{this.translateWordForRadio(this.state.formJson.guideContainer.rootPanel.items['guideradiobutton_IND1-i'].options)[0].split('=')[1]}
              <Radiobutton _value={this.state.countryFormData.countryIndiaDecForm !== undefined ? this.state.countryFormData.countryIndiaDecForm.creditFacilityDescription : ''}
                setInputvalue={this.setCreditFacilities}
                name="creditFacilityDescription" value="true" /></label>
            <label>{this.translateWordForRadio(this.state.formJson.guideContainer.rootPanel.items['guideradiobutton_IND1-i'].options)[1].split('=')[1]}
              <Radiobutton _value={this.state.countryFormData.countryIndiaDecForm !== undefined ? this.state.countryFormData.countryIndiaDecForm.creditFacilityDescription : ''}
                setInputvalue={this.setCreditFacilities}
                name="creditFacilityDescription" value="false" /></label>
          </div>
        </fieldset>
        {this.state.countryFormData.countryIndiaDecForm.creditFacilityDescription ? indiaDeclarationFormJsx : ''}
        <div className="gdocs-clear-float"></div>
        {this.state.countryFormData.countryIndiaDecForm.creditFacilityDescription && this.state.noOfBankName <= 3 ? addBankJsx : ''}
        <div className="gdocs-clear-float"></div>
        <div className="gdocs-divide"></div>
        <fieldset className="credit-facilities-wrapper gdocs-mtop-30">
          <legend className="credit-facilities-position">{this.translations(this.state.formJson.guideContainer.rootPanel.items['guideradiobutton_IND5-i'].title)}</legend>
          <div className="credit-facilities-position">
            <label>{this.translateWordForRadio(this.state.formJson.guideContainer.rootPanel.items['guideradiobutton_IND5-i'].options)[0].split('=')[1]}
              <Radiobutton _value={this.state.countryFormData.countryIndiaDecForm !== undefined ? this.state.countryFormData.countryIndiaDecForm.acceptForeignContribution : ''}
                setInputvalue={this.setAcceptingForeign}
                name="setAcceptingForeign" value="true" /></label>
            <label>{this.translateWordForRadio(this.state.formJson.guideContainer.rootPanel.items['guideradiobutton_IND5-i'].options)[1].split('=')[1]}
              <Radiobutton _value={this.state.countryFormData.countryIndiaDecForm !== undefined ? this.state.countryFormData.countryIndiaDecForm.acceptForeignContribution : ''}
                setInputvalue={this.setAcceptingForeign}
                name="setAcceptingForeign" value="false" /></label>
          </div>
        </fieldset>
        <fieldset className="credit-facilities-wrapper">
          <legend className="credit-facilities-position">{this.translations(this.state.formJson.guideContainer.rootPanel.items['guideradiobutton_IND6-i'].title)}</legend>
          <div className="credit-facilities-position">
            <label>{this.translateWordForRadio(this.state.formJson.guideContainer.rootPanel.items['guideradiobutton_IND6-i'].options)[0].split('=')[1]}
              <Radiobutton _value={this.state.countryFormData.countryIndiaDecForm !== undefined ? this.state.countryFormData.countryIndiaDecForm.registeredOutsideIndia : ''}
                setInputvalue={this.setRegisteredOutside}
                name="setRegisteredOutside" value="true" /></label>
            <label>{this.translateWordForRadio(this.state.formJson.guideContainer.rootPanel.items['guideradiobutton_IND6-i'].options)[1].split('=')[1]}
              <Radiobutton _value={this.state.countryFormData.countryIndiaDecForm !== undefined ? this.state.countryFormData.countryIndiaDecForm.registeredOutsideIndia : ''}
                setInputvalue={this.setRegisteredOutside}
                name="setRegisteredOutside" value="false" /></label>
          </div>
        </fieldset>
        {
          this.state.countryFormData && this.state.countryFormData.countryIndiaDecForm && this.state.countryFormData.countryIndiaDecForm.registeredOutsideIndia ?
            <fieldset className="credit-facilities-wrapper">
              <legend className="credit-facilities-position">{this.translations(this.state.formJson.guideContainer.rootPanel.items['guideradiobutton_IND7-i'].title)}</legend>
              <div className="credit-facilities-position">
                <label>{this.translateWordForRadio(this.state.formJson.guideContainer.rootPanel.items['guideradiobutton_IND7-i'].options)[0].split('=')[1]}
                  <Radiobutton _value={this.state.countryFormData.countryIndiaDecForm !== undefined ? this.state.countryFormData.countryIndiaDecForm.liaisonOffice : ''}
                    setInputvalue={this.setHaveBranch}
                    name="setHaveBranch" value="true" />
                </label>
                <label>{this.translateWordForRadio(this.state.formJson.guideContainer.rootPanel.items['guideradiobutton_IND7-i'].options)[1].split('=')[1]}
                  <Radiobutton _value={this.state.countryFormData.countryIndiaDecForm !== undefined ? this.state.countryFormData.countryIndiaDecForm.liaisonOffice : ''}
                    setInputvalue={this.setHaveBranch}
                    name="setHaveBranch" value="false" />
                </label>
              </div>
            </fieldset>
            : null
        }
        <fieldset className="credit-facilities-wrapper">
          <div className="field_row">
            <legend className="credit-facilities-position">{this.translations(this.state.formJson && this.state.formJson.guideContainer && this.state.formJson.guideContainer.rootPanel && this.state.formJson.guideContainer.rootPanel.items['static_text_noOfSign'].text)}</legend>
            <div className="credit-facilities-position">
              <SimpleDropdown
                name="indiaDeclarationFormDropdown"
                id="indiaDeclarationFormDropdown"
                options={[{ id: 1, name: 1 }, { id: 2, name: 2 }, { id: 3, name: 3 }, { id: 4, name: 4 }]}
                optionTextSelector="name"
                // defaultValue={this.state.countryFormData.countryIndiaDecForm.noOfSign}
                value={this.state.countryFormData && this.state.countryFormData.countryIndiaDecForm !== undefined && this.state.countryFormData.countryIndiaDecForm.noOfSign}
                _onChange={this.setSignatoriesRequired}
              />
            </div>
          </div>
        </fieldset>
        <div className="gdocs-clear-float"></div>

      </div>
      <div key="buttons-wrapper" className="form-buttons-section country-form-buttons-section">
        <div className="form-buttons-wrapper">
          {buttonJsx}
        </div>
      </div>
    </div>
    ) : '');
  }
}
const mapStateToProps = state => {
  return {
    lang: state.lang
  }
}
export default connect(mapStateToProps)(IndiaDeclarationForm);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CountryForms/IndiaDeclarationForm.js